export const adminMemberRoles = [
  { key: 'account_coordinator', title: 'Account Coordinator', group: 'team_lead' },
  { key: 'account_manager', title: 'Account Manager', group: 'team_lead' },
  { key: 'account_supervisor', title: 'Account Supervisor', group: 'team_lead' },
  { key: 'client_success', title: 'Client Success', group: 'support' },
  { key: 'support_supervisor', title: 'Support Supervisor', group: 'team_lead' },
  { key: 'template_developer', title: 'Template Developer', group: 'support' },
  { key: 'template_quality_controller', title: 'Template Quality Controller', group: 'support' },
  { key: 'template_supervisor', title: 'Template Supervisor', group: 'team_lead' },
]

export const agencyMemberRoles = [
  { key: 'associate_agent', title: 'Associate Agent', group: 'agent' },
  { key: 'lead_agent', title: 'Lead Agent', group: 'agent' },
  { key: 'office_support', title: 'Office Support', group: 'support' },
  { key: 'remote_support', title: 'Remote Support', group: 'support' },
]

export const agencyTeamMemberSort = {
  lead_agent: 1,
  associate_agent: 2,
  office_support: 3,
  remote_support: 4,
}

export default adminMemberRoles
